import { Button, DatePicker, Form, Select } from 'antd'
import {
  filterOption,
  normalizeDate,
  periodMap,
} from 'src/pages/finSystem/balanceSummary/reports/utils'
import {
  PERIOD_OPTIONS,
  TYPE_OPTIONS,
} from 'src/pages/finSystem/balanceSummary/reports/const'

import { useWalletOptions } from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/hook'
import {
  CommissionFilter,
  FormCommissionValue,
} from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/types'

type Props = {
  filters: CommissionFilter
  setFilters: (values: Partial<CommissionFilter>) => void
  resetFilters: () => void
  initialValueForm: FormCommissionValue
}

export const CommissionListFilter = ({
  filters,
  setFilters,
  resetFilters,
  initialValueForm,
}: Props) => {
  const { walletOptions, currencyOptions } = useWalletOptions()
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker
  const { Item } = Form

  const handleChangeForm = (valueField: Record<string, any>) => {
    const [key, value] = Object.entries(valueField)[0]

    if (key === 'periodDatePicker') {
      const [dateFromPicker, dateToPicker] = value ?? []
      const dateFrom = normalizeDate(dateFromPicker)
      const dateTo = normalizeDate(dateToPicker)
      setFilters({ dateFrom, dateTo })
    }

    if (key === 'period') {
      const { dateFrom, dateTo } = periodMap[value] ?? {}
      setFilters({ dateFrom, dateTo })
    }

    if (key === 'type') {
      setFilters({ [key]: value })
    }
  }

  const checkVisibleReset = () => {
    const keys = Object.keys(filters)

    if (keys.length === 0) {
      return false
    }
    if (keys.length === 1 && keys[0] === 'sorterField') {
      return false
    }
    return true
  }

  const period = Form.useWatch('period', form)
  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleChangeForm}
      initialValues={initialValueForm}
    >
      <Item name="type" key="type" style={{ width: 200 }}>
        <Select placeholder="Type" allowClear options={TYPE_OPTIONS} />
      </Item>

      <Item name="walletIds" key="walletIds" style={{ width: 200 }}>
        <Select
          placeholder="Wallets"
          mode="multiple"
          options={walletOptions}
          filterOption={filterOption}
          onOpenChange={() => {
            const value = form.getFieldValue('walletIds')
            setFilters({ walletIds: value })
          }}
          onDeselect={(value) => {
            const current = form.getFieldValue('walletIds')
            setFilters({ walletIds: current.filter((v: any) => v !== value) })
          }}
        />
      </Item>

      <Item name="currencies" key="currencies" style={{ width: 200 }}>
        <Select
          placeholder="Currency"
          mode="multiple"
          options={currencyOptions}
          filterOption={filterOption}
          onOpenChange={() => {
            const value = form.getFieldValue('currencies')
            setFilters({ currencies: value })
          }}
          onDeselect={(value) => {
            const current = form.getFieldValue('currencies')
            setFilters({ currencies: current.filter((v: any) => v !== value) })
          }}
        />
      </Item>

      <Item name="period" key="period" style={{ width: 180 }}>
        <Select placeholder="Period" options={PERIOD_OPTIONS} allowClear />
      </Item>

      {period === 'date_range' && (
        <Item
          name="periodDatePicker"
          key="periodDatePicker"
          style={{ width: 180 }}
        >
          <RangePicker style={{ width: 250 }} />
        </Item>
      )}
      {checkVisibleReset() && (
        <Item style={{ marginLeft: period === 'date_range' ? 70 : 0 }}>
          <Button
            onClick={() => {
              form.setFieldsValue({
                search: undefined,
                type: undefined,
                walletIds: undefined,
                currencies: undefined,
                period: undefined,
                periodDatePicker: undefined,
              })
              resetFilters()
            }}
          >
            Reset filters
          </Button>
        </Item>
      )}
    </Form>
  )
}
